import React from "react";
import styled from "styled-components";
import { Label } from "../globals";
import { CheckBoxInput } from "./Buttons";

export default function NewInputSwitchComponent({
  type = "simple",
  label,
  name,
  options = [],
  value,
  onChange,
  disabled = false,
  touches = false,
  error = false,
  childrenStyle = {},
  showCheckBox = false,
  labelClassName = "",
}) {
  if (type == "multiple" && !value) {
    value = [];
  }
  return (
    <>
      {label && (
        <Label className={labelClassName} error={error}>
          {label}
        </Label>
      )}
      <InputSwitchComponentStyled>
        {options.map((d, idx) => (
          <div
            key={`${idx}_${d.value}`}
            className={`block extra_border ${
              value && value.includes(d.value) ? "active" : ""
            } cursor-pointer  ${touches ? (idx == 0 ? "touches" : "") : ""}`}
            style={childrenStyle}
            onClick={
              disabled || showCheckBox
                ? () => console.log("DISABLED")
                : () => {
                    if (type == "multiple") {
                      onChange({
                        target: {
                          name,
                          value: value.includes(d.value)
                            ? value.filter((s) => s !== d.value)
                            : [...value, d.value],
                        },
                      });
                    } else {
                      onChange({ target: { name, value: d.value } });
                    }
                  }
            }
          >
            {showCheckBox ? (
              <CheckBoxInput
                checked={value && value.includes(d.value)}
                text={d.label}
                onChange={
                  disabled
                    ? () => console.log("DISABLED")
                    : () => {
                        if (type == "multiple") {
                          onChange({
                            target: {
                              name,
                              value: value.includes(d.value)
                                ? value.filter((s) => s !== d.value)
                                : [...value, d.value],
                            },
                          });
                        } else {
                          onChange({ target: { name, value: d.value } });
                        }
                      }
                }
              />
            ) : (
              d.label
            )}
          </div>
        ))}
      </InputSwitchComponentStyled>
    </>
  );
}

const InputSwitchComponentStyled = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  .block:first-child {
    border-radius: 2px 0px 0px 2px;
    border-width: 1px 0px 1px 1px;
  }
  .block.touches {
    border-radius: 0px 0px 0px 0px;
  }
  .block:last-child {
    border-width: 1px 1px 1px 0px;
    border-radius: 0px 2px 2px 0px;
  }
  .block {
    display: flex;
    align-items: center;
    justify-content: center;
    // flex: 1;
    padding: 8px 10px;
    border-width: 1px 0px 1px 0px;
    border-style: solid;
    border-color: #d9d9d9;
    background: #fcfcfc;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #6c6c6c;
    & .checkbox_text {
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #6c6c6c;
    }
    &.extra_border {
      border-width: 1px;
    }
    &.active,
    &.active .checkbox_text {
      border-width: 1px;
      border-color: #03b0f7;
      background: #edf9fe;
      color: #03b0f7;
    }
  }
`;
